// Hooks
import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

// Constants/Libs
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import { SocialInboxConversationMessages } from '@/components/pages/conversations/SocialInbox';
import { SocialInboxDirectMessages } from '@/components/pages/conversations/SocialInbox/components/SocialInboxChatView/SocialInboxMessages/SocialInboxDirectMessages/SocialInboxDirectMessages';

export const SocialInboxMessages = () => {
    const { currentSocialInbox } = useSocialInboxNavigation();

    if (currentSocialInbox === SOCIAL_INBOX_META.dm.key) {
        return <SocialInboxDirectMessages />;
    }

    return <SocialInboxConversationMessages />;
};
